export default __webpack_public_path__ + "static/media/context_loader.cb3f345f.gif";